import { render, staticRenderFns } from "./clientData.vue?vue&type=template&id=77547cca&"
import script from "./clientData.vue?vue&type=script&lang=js&"
export * from "./clientData.vue?vue&type=script&lang=js&"
import style0 from "./clientData.vue?vue&type=style&index=0&id=77547cca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports